import { Warning } from "@procore/core-icons";
import { Box, Button, colors, Typography } from "@procore/core-react";
import { useTranslation } from "react-i18next";

type GuidanceBannerProps = {
    onTroubleshoot: () => void;
};

const BANNER_BG = "#FDF6E2";
const BANNER_HEIGHT = 40;

export function GuidanceBanner({ onTroubleshoot }: GuidanceBannerProps) {
    const { t } = useTranslation();

    return (
        <Box
            role="status"
            data-testid="gpu-guidance-banner"
            display="flex"
            alignItems="center"
            justifyContent="center"
            style={{
                boxSizing: "border-box",
                width: "100%",
                height: BANNER_HEIGHT,
                flexShrink: 0,
                gap: 8,
                padding: "0 24px",
                background: BANNER_BG,
                color: colors.gray15,
                boxShadow: "0px 2px 6px 0px rgba(0, 0, 0, 0.1)",
                zIndex: 1000,
            }}
        >
            <Warning size="md" aria-hidden="true" style={{ color: "#2F2404", flexShrink: 0, width: 20, height: 20 }} />
            <Typography intent="body" style={{ color: colors.gray15 }}>
                {t("gpuGuidance.banner.message")}
            </Typography>
            <Button variant="secondary" size="sm" onClick={onTroubleshoot}>
                {t("gpuGuidance.banner.troubleshoot")}
            </Button>
        </Box>
    );
}
